import React from 'react';
import { SvgIcon } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";
import { alpha } from '@material-ui/core/styles/colorManipulator';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  iconWrapper: {
    backgroundColor: alpha(theme.palette.primary.main, .1),
    borderRadius: '50%',
    height: '2.3rem',
    width: '2.3rem',
  }
}));

export default function IconHolder(props) {

  const { icon, viewBox, fontSize } = props;
  const iconWrapper = useStyles().iconWrapper;
  const vb = viewBox || "0 0 45 45";

  return (
    <div className={`d-flex justify-content-center align-items-center icon-wrap ${iconWrapper}`} >
      <SvgIcon component={icon} color="primary" fontSize={fontSize} viewBox={vb} />
    </div>
  )
}

IconHolder.propTypes = {
  icon: PropTypes.any.isRequired,
  viewBox: PropTypes.string
}




// WEBPACK FOOTER //
// ./src/components/Common/IconHolder.js